<template>
  <div :class="['flex flex-column', { 'ml-4': !collapsed }]">
    <div class="flex gap-4 items-center">
      <div
        class="relative rounded-full bg-orange-100 w-10 h-10 flex items-center justify-center shrink-0"
      >
        <div
          v-if="unassignedEvents.length"
          class="absolute inline-flex items-center justify-center w-5 h-5 text-xxs font-bold text-white bg-red-600 border-2 border-white rounded-full -top-2 -right-2"
        >
          {{ unassignedEvents.length }}
        </div>
        <WarningIcon class="h-5 text-yellow-700" />
      </div>
      <div
        v-if="!collapsed"
        class="font-normal flex items-center justify-between gap-4"
      >
        Unassigned
        <div
          id="unassignedRowToggleButton"
          class="rounded-lg p-1 hover:bg-gray-100 cursor-pointer"
          data-tippy-content="Undock Unassigned Events"
        >
          <UndockIcon class="w-4" />
        </div>
      </div>
    </div>
    <div
      v-if="!collapsed"
      class="flex flex-column border-t mt-2 py-2 font-normal text-xs"
    >
      <div class="flex gap-4">
        <div class="w-10 text-center font-semibold">
          {{ noAvailabilityEvents.length }}
        </div>
        Not Assigned
      </div>
      <div class="flex gap-4">
        <div class="w-10 text-center font-semibold">
          {{ holdEvents.length }}
        </div>
        Temporary Holds
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import WarningIcon from "@/images/alert-triangle.svg?component";
import UndockIcon from "@/images/undock-icon.svg?component";
import { TimelineEvent, TimelineResource } from "@/typings/scheduler";

const props = defineProps<{
  unassignedEvents: TimelineEvent[];
  resource: TimelineResource;
  collapsed: boolean;
}>();

const holdEvents = computed(() => {
  return props.unassignedEvents.filter((event) => event.ghost);
});
const noAvailabilityEvents = computed(() => {
  return props.unassignedEvents.filter((event) => !event.ghost);
});
</script>

<style>
.unassigned-resource-row {
  height: 7em !important;
}
</style>
